'use client';

import { useEffect, useRef, type ReactNode } from 'react';

interface ScrollFadeSectionProps {
  children: ReactNode;
  className?: string;
}

const ScrollFadeSection = ({ children, className = '' }: ScrollFadeSectionProps) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = ref.current;
    if (!container) return;

    const items = container.querySelectorAll('[data-scroll-fade]');
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.remove('opacity-0', 'translate-y-5');
          }
        });
      },
      { threshold: 0.12 },
    );

    items.forEach(item => observer.observe(item));
    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      className={className}
    >
      {children}
    </div>
  );
};

export default ScrollFadeSection;
